import { Link, NavLink } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { useState } from "react";

const links = [
  { to: "/", label: "Inicio" },
  { to: "/menu", label: "Menú" },
  { to: "/historia", label: "Historia" },
  { to: "/galeria", label: "Galería" },
  { to: "/ubicacion", label: "Ubicación" },
];

const WHATSAPP = "https://wa.me/525555555555?text=Hola%2C%20quiero%20hacer%20un%20pedido%20de%20J.R.%20Tacos%20El%20Paisa";

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-zinc-200/70">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="public-logo-link">
          <div className="w-11 h-11 rounded-xl bg-brand text-white flex items-center justify-center font-display font-black text-xl shadow-md">JR</div>
          <div className="leading-tight">
            <div className="font-display text-lg font-bold tracking-tight">Tacos El Paisa</div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500">Ecatepec · Tradición</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`public-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                  isActive ? "bg-zinc-100 text-zinc-900" : "text-zinc-600 hover:text-zinc-900 hover:bg-zinc-50"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={WHATSAPP}
            target="_blank"
            rel="noreferrer"
            className="hidden sm:inline-flex btn-brand px-5 h-11 items-center text-sm"
            data-testid="public-nav-whatsapp"
          >
            Pedir por WhatsApp
          </a>
          <button
            className="md:hidden w-11 h-11 rounded-full border border-zinc-200 flex items-center justify-center"
            onClick={() => setOpen(!open)}
            data-testid="public-nav-toggle"
            aria-label="Menú"
          >
            {open ? <X size={22} weight="bold" /> : <List size={22} weight="bold" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl text-base font-semibold ${
                    isActive ? "bg-zinc-100" : "text-zinc-700"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a href={WHATSAPP} target="_blank" rel="noreferrer" className="btn-brand px-5 h-12 inline-flex items-center justify-center mt-2">Pedir por WhatsApp</a>
          </div>
        </div>
      )}
    </header>
  );
}

export { WHATSAPP };
